// extracted by mini-css-extract-plugin
module.exports =  {"container":"_B0kyj","remove-icon":"Knh4Cz","removeIcon":"Knh4Cz"};